import { useEffect, useMemo, useState } from 'react';
import { useStoreon } from 'storeon/react';
import { FETCH_FAVORITE_ADDRESS } from 'actions';
import { isFavoriteAddressEnabled } from 'selectors';
import { FavoriteAddressViewState } from 'types/favorite-address';
import { State } from 'store/types';
import { CHECKOUT_INFO } from '../../../common/constants/local-storage-constants';

export const useFavoriteAddress = (): FavoriteAddressViewState => {
  const { cookies, dispatch, orchestratorHost, favoriteAddress } = useStoreon<State>(
    'cookies',
    'dispatch',
    'orchestratorHost',
    'favoriteAddress',
  );

  const enabled = isFavoriteAddressEnabled(cookies);

  // Стейт-триггер для перезапуска целевого useEffect
  const [storageVersion, setStorageVersion] = useState(0);

  useEffect(() => {
    const handleStorageChange = (event: Event) => {
      if ('key' in event && event.key !== CHECKOUT_INFO) {
        return;
      }

      if ('detail' in event && (event as CustomEvent).detail?.key !== CHECKOUT_INFO) {
        return;
      }

      setStorageVersion((prev) => prev + 1);
    };

    globalThis.addEventListener('storage', handleStorageChange);
    globalThis.addEventListener('local-storage-update', handleStorageChange);

    return () => {
      globalThis.removeEventListener('storage', handleStorageChange);
      globalThis.removeEventListener('local-storage-update', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (enabled) {
      dispatch(FETCH_FAVORITE_ADDRESS.init);
    }
  }, [enabled, dispatch, orchestratorHost, storageVersion]);

  return useMemo(
    () => ({
      enabled,
      loading: favoriteAddress.loading,
      favoriteAddress: favoriteAddress.data,
    }),
    [enabled, favoriteAddress.loading, favoriteAddress.data],
  );
};
